import React from 'react';
import cx from 'classnames';
import styles from './index.module.scss.js';

const Icon = ({
  className,
  style,
  isHovered,
  isActive,
  kind,
  icon,
  iconActive,
  hasIconDefaultTransparency,
  ...props
}) => /* @__PURE__ */ React.createElement(
  "span",
  {
    ...props,
    className: cx(styles.box, className),
    style,
    "aria-hidden": true
  },
  /* @__PURE__ */ React.createElement(
    "span",
    {
      className: cx(styles.icon, styles.default, {
        [styles.show]: !isActive || hasIconDefaultTransparency && !iconActive || !isActive && isHovered
      })
    },
    icon
  ),
  /* @__PURE__ */ React.createElement(
    "span",
    {
      className: cx(styles.icon, styles.active, {
        [styles.show]: isActive
      }),
      style: {
        "--color": kind === "yellow" || kind === "green" ? "#000000" : "inherit"
      }
    },
    iconActive ?? icon
  )
);

export { Icon };
//# sourceMappingURL=index.js.map
